<template>
  <div class="asNotice" data-cy="notice">
    <slot>
      <ul v-if="Array.isArray(notice) && notice.length > 0" class="asNotice_list">
        <li v-for="(note, i) in notice" :key="i" class="asNotice_item">{{ note }}</li>
      </ul>
      <template v-else-if="notice && notice.length > 0">
        {{ notice }}
      </template>
    </slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    notice: {
      type: [String, Array],
      default: ''
    }
  }
})
</script>

<style lang="scss">
  .asNotice {
    max-width: 342px;
    margin: 0 auto;
    padding: 13px 14px 13px 13px;
    border-radius: 6px;
    border: 1px solid rgb(255, 255, 255);

    color: rgb(255, 255, 255);
    font-size: 14px;
    line-height: 20px;

    &.-grey {
      border: 1px solid #4c5264;

      color: #4c5264;
    }

    &:empty {
      display: none;
    }

    &_list {
      margin: 0;
      padding-left: 15px;
    }

    &_item {

    }
  }
</style>
